import { EntityType, Locale } from '@frontend/common';
import { IGroup, NodeType } from '@frontend/group/types';
import { getCorrectTranslation } from '@frontend/lang';
import { DocType, IMAGE_MIME_TYPES, useBlobRepository, useDocumentRepository } from '@frontend/repository';

export class Group implements IGroup {
    num_members: number | null;
    num_entities: number | null;
    name: string;
    name_nl_be: string | null;
    name_en_us: string | null;
    name_fr_fr: string | null;
    name_de_de: string | null;
    node_type: NodeType;
    auto_generated: boolean;
    update_timestamp: string;
    id: string;
    account_id: string;
    entity_type: EntityType;
    creation_timestamp: string;

    constructor(group: IGroup) {
        this.num_members = group.num_members;
        this.num_entities = group.num_entities;
        this.name = group.name;
        this.name_nl_be = group.name_nl_be;
        this.name_en_us = group.name_en_us;
        this.name_fr_fr = group.name_fr_fr;
        this.name_de_de = group.name_de_de;
        this.node_type = group.node_type;
        this.auto_generated = group.auto_generated;
        this.update_timestamp = group.update_timestamp;
        this.id = group.id;
        this.account_id = group.account_id;
        this.entity_type = group.entity_type;
        this.creation_timestamp = group.creation_timestamp;
    }

    getName(locale?: Locale): string {
        return getCorrectTranslation(locale, this, 'name');
    }

    async getImage(documentRepository: ReturnType<typeof useDocumentRepository>, type?: EntityType): Promise<string | null> {
        let service = await documentRepository.getFiles(type ?? EntityType.GROUP, this.id);
        const docs = service.getDocuments();
        const image = docs.find((d) => service.getType(d.id) === DocType.IMAGE);
        if (image) return await service.getUrl(image.id);
        return null;
    }

    async getBlobImage(blobRepository: ReturnType<typeof useBlobRepository>, type?: EntityType): Promise<string | null> {
        const info = await blobRepository.getBlob(this.account_id, type ?? EntityType.GROUP, this.id);
        if (info && IMAGE_MIME_TYPES.includes(info.mimeType)) return info.url;
        return null;
    }
}
